export const capitalize = (text: string) => {
    const chars = text.split('');

    chars[0] = chars[0].toUpperCase();

    return chars.join('');
};

export const generateRandomString = (length: number): string => {
    const a = 97;
    const z = 122;

    const letters: number[] = [];

    for (let i = a; i <= z; i++) {
        letters.push(i);
    }

    const randomString: string[] = [];

    const getRandomLetter = () => letters[Math.floor(Math.random() * letters.length)];

    while (randomString.length < length) {
        randomString.push(String.fromCharCode(getRandomLetter()));
    }

    return randomString.join('');
};
